export default __webpack_public_path__ + "static/portal/img/fig-3.67669a4.png";